var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBellNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.236 14c.47.415 1.088.667 1.764.667.676 0 1.294-.252 1.764-.667M12 5.333a4 4 0 10-8 0c0 2.06-.52 3.471-1.1 4.404-.49.787-.735 1.18-.726 1.29.01.122.036.168.134.24.088.066.487.066 1.285.066h8.815c.797 0 1.196 0 1.284-.065.098-.073.124-.12.134-.24.009-.11-.236-.504-.726-1.291-.58-.933-1.1-2.344-1.1-4.404z",
    stroke: "#001529",
    strokeOpacity: 0.88,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconBellNotifications;